import styled, { keyframes } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { A4_FACTOR } from 'builder/modules/constants'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { Icon24, Icon20 } from 'builder/components/Icon'

export const DocumentPreviewContainer = styled.div`
  position: relative;
  overflow: hidden;
  background-color: ${Colors.White};

  &:before {
    content: '';
    display: block;
    padding-bottom: ${100 / A4_FACTOR}%;
  }
`

export const DocumentPreviewUnavailable = styled.div`
  ${Typography.Caption};
  color: ${Colors.Neutral50};
  max-width: '100%';
  text-align: center;
  position: absolute;
  left: 0;
  top: 50px;
  right: 0;
  bottom: 0;

  ${Media.Phone`
    ${Typography.Tiny};
    top: 25px;
  `}
`

export const DocumentPreviewPlaceholder = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-image: url(${require('images/builder/panel/document/placeholder.svg')});
  background-repeat: no-repeat;
  background-size: contain;
`

export const DocumentPreviewImage = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
`

export const CritiqueInReview = styled.div`
  position: absolute;
  left: 12px;
  top: 12px;
  z-index: 99999;
  background-color: ${Colors.White};
  color: ${Colors.Neutral90};
  font-size: 14px;
  gap: 2px;
  display: flex;
  align-items: center;
  filter: drop-shadow(0px 2px 4px rgba(15, 56, 113, 0.08))
    drop-shadow(0px 1px 2px rgba(15, 56, 113, 0.12))
    drop-shadow(0px 0px 1px rgba(15, 56, 113, 0.32));
  border-radius: 16px;
  padding: 4px 8px;

  ${Media.Phone`
    padding: 4px;
  `}
`

const rotation = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

export const Spinner = styled(Icon24.Spinner)`
  color: ${Colors.Blue50};
  animation: ${rotation} 0.5s infinite linear;
`

export const CritiqueFailed = styled.div`
  position: absolute;
  left: 3px;
  top: 3px;
  z-index: 99999;
  background-color: ${Colors.Red10};
  color: ${Colors.Red50};
  gap: 8px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 4px 8px;
  box-shadow: 0px 2px 4px -1px rgba(15, 56, 113, 0.08), 0px 8px 20px -4px rgba(15, 56, 113, 0.12);
  font-size: 14px;
  width: 98%;
  cursor: default;
`

export const Error = styled.div`
  background-color: ${Colors.Red50};
  border-radius: 100%;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${Media.Phone`
    width: 18px;
    height: 18px;
    margin-bottom: auto;
    margin-top: 4px;
  `}
`

export const ErrorClose = styled(Icon20.Close)`
  color: white;
  width: 14px;
  height: 14px;
`

export const Close = styled(Icon24.Close)`
  color: ${Colors.Neutral100};
  margin-left: auto;
  cursor: pointer;
`

export const CritiqueFinished = styled.div`
  position: absolute;
  left: 3px;
  top: 3px;
  z-index: 99999;
  background-color: ${Colors.Blue10};
  color: ${Colors.Neutral90};
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 4px 8px;
  box-shadow: 0px 2px 4px -1px rgba(15, 56, 113, 0.08), 0px 8px 20px -4px rgba(15, 56, 113, 0.12);
  font-size: 14px;
  width: 98%;
  cursor: default;
  justify-content: flex-end;
  cursor: pointer;
`

export const ArrowRight = styled(Icon24.ChevronRight)`
  color: ${Colors.Blue50};
`

export const StarContainer = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 100%;
  background-color: ${Colors.Indigo80};
  border: 3px solid white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`

export const Star = styled(Icon20.Star)`
  color: white;
`

export const ReviewAvatar = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 100%;
  margin-right: auto;
  margin-left: -8px;
`

export const ReadReview = styled.span`
  ${Media.Phone`
    display: none;
  `}
`
